export default "__VITE_ASSET__C$vx7n38__"